module.exports = __webpack_public_path__ + "img/testpaper_audio_volume.fa20105c.svg";